import List from '../../../components/People/Payroll/List'
import PageTitle from '../../../elements/PageTitle'
import {Breadcrumb, Card, Layout, Row} from 'antd'
import React, {Fragment} from 'react'

const {Content} = Layout

function Payroll(props) {
  return (
    <Fragment>
      <Content style={{margin: '0px 0px'}}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/people">People</Breadcrumb.Item>
              <Breadcrumb.Item>Payroll</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Payroll'}
              subtitle={'Payroll'}
              color={'#FF6138'}
              iconType={'money-collect'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{padding: 10}}>
          <Card>
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

Payroll.propTypes = {}
Payroll.defaultProps = {}

export default Payroll
